import { useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import * as utils from "../../../_metronic/utils/utils";
import * as auth from "../../store/ducks/auth.duck";
import * as config from "../../store/ducks/config.duck";
import { createFormikValidation, validaCnpj, validaCpf } from "../../utils/Utils";
import { cadastrar, login } from "../../crud/auth.crud";
import styles from "../../../styles/Login.module.css";
import Step1 from "../../components/signin/Step1";
import Step2 from "../../components/signin/Step2";
import Step3 from "../../components/signin/Step3";
import Step4 from "../../components/signin/Step4";
import { RiWhatsappLine } from "react-icons/ri";
import { useRef } from "react";
import moment from "moment";
import { useAlert } from "../../context/AlertContext";
import { Constants } from "../../utils/Constants";

const Signin = (props) => {
    const [submitting, setSubmitting] = useState(false);
    const [step, setStep] = useState(1);
    const [planoSelecionado, setPlanoSelecionado] = useState(null);
    const [credentials, setCredentials] = useState(null);

    const history = useHistory();

    const formRef = useRef(null);

    const { showAlert } = useAlert();

    const formatarAntesEnvio = (values) => {
        return {
            ...values,
            step,
            plano: planoSelecionado?.value ?? "",
            data_vencimento_cartao: values.data_vencimento_cartao ? `20${values.data_vencimento_cartao.substring(3, 5)}-${values.data_vencimento_cartao.substring(0, 2)}-01` : "",
        };
    };

    const onSubmit = (values) => {
        formRef.current.setTouched({});

        setSubmitting(true);

        cadastrar(formatarAntesEnvio(values))
            .then(() => {
                if (step === 4) {
                    setCredentials({
                        usuario: values.cli_email,
                        password: values.password,
                    });
                }
                setStep((ant) => ant + 1);

                window.scrollTo(0, 0);
            })
            .catch((err) => {
                showAlert({
                    icon: "error",
                    title: "Ops!",
                    text: Array.isArray(err?.response?.data?.errors) ? err?.response?.data?.errors[0] : "Parece que houve um problema. Por favor, entre em contato com o suporte.",
                    textStyle: { textAlign: "center" },
                    confirmButton: true,
                    confirmText: "Ok",
                });
            })
            .finally(() => setSubmitting(false));
    };

    const getInitialValues = () => {
        return {
            cli_nome: "",
            cli_cpf_cnpj: "",
            cli_email: "",
            cli_telefone: "",
            password: "",
            password_confirmation: "",
            nome_titular_cartao: "",
            documento_titular_cartao: "",
            numero_cartao: "",
            data_vencimento_cartao: "",
            cvv: "",
            cep: "",
            logradouro: "",
            numero: "",
            bairro: "",
            cidade: "",
            estado: "",
        };
    };

    const validate = (values) => {
        const map = new Map();
        const errors = {};

        if (step === 1) {
            map.set("cli_nome", "nome");
            map.set("cli_cpf_cnpj", "CPF/CNPJ");
            map.set("cli_email", "e-mail");
            map.set("cli_telefone", "telefone");
            if (values.cli_nome.split(" ").length < 2) {
                errors.cli_nome = "Por favor, insira seu nome completo.";
            }
        } else if (step === 2) {
            map.set("password", "senha");
            map.set("password_confirmation", "confirme sua senha");

            if (values.password !== values.password_confirmation) {
                errors.password_confirmation = "As senhas não conferem.";
            }
        } else if (step === 4) {
            map.set("nome_titular_cartao", "nome do titular");
            map.set("documento_titular_cartao", "CPF/CNPJ do titular");
            map.set("numero_cartao", "número do cartão");
            map.set("data_vencimento_cartao", "data de vencimento do cartão");
            map.set("cvv", "CVV");
            map.set("cep", "CEP");
            map.set("logradouro", "logradouro");
            map.set("numero", "número");
            map.set("bairro", "bairro");
            map.set("cidade", "cidade");
            map.set("estado", "estado");

            if (values.nome_titular_cartao.split(" ").length < 2) {
                errors.nome_titular_cartao = "Por favor, insira o nome completo do titular do cartão.";
            }

            if ((values.documento_titular_cartao.length < 15 && !validaCpf(values.documento_titular_cartao)) || (values.documento_titular_cartao.length > 14 && !validaCnpj(values.documento_titular_cartao))) {
                errors.documento_titular_cartao = "O CPF/CNPJ do titular está incorreto";
            }

            if (/^(34|37)/.test(values.numero_cartao.replace(/[\s_]/g, ""))) {
                // amex
                if (values.numero_cartao?.replace(/\D/g, "").length != 15) {
                    errors.numero_cartao = "O número do cartão está incorreto";
                }
                if (values.cvv?.replace(/\D/g, "").length != 4) {
                    errors.cvv = "O CVV está incorreto";
                }
            } else {
                if (values.numero_cartao?.replace(/\D/g, "").length != 16) {
                    errors.numero_cartao = "O número do cartão está incorreto";
                }
                if (values.cvv?.replace(/\D/g, "").length != 3) {
                    errors.cvv = "O CVV está incorreto";
                }
            }

            if (!moment(values.data_vencimento_cartao, "MM/YY").isValid() || moment(values.data_vencimento_cartao, "MM/YY").isBefore(moment())) {
                errors.data_vencimento_cartao = "A data de validade do cartão é inválida.";
            }
        }

        return { ...errors, ...createFormikValidation(map, values) };
    };

    const returnButton = () => {
        if (step === 1) {
            history.push("/");
        } else {
            setStep((ant) => ant - 1);
        }
    };

    const textoReturnButton = () => {
        const obj = {
            1: "Cadastre-se",
            2: "Criar senha",
            3: "Hora de escolher um plano",
            4: "Dados de pagamento",
        };

        return obj[step];
    };

    const textoSubtitulo = () => {
        const obj = {
            1: "Insira os dados solicitados abaixo para criar sua conta.",
            2: "Crie uma senha para acessar sua conta.",
            3: "Escolha abaixo o plano que mais se encaixa nas suas necessidades.",
            4: "Informe abaixo seus dados de pagamento.",
        };

        return obj[step];
    };

    const entrar = async () => {
        setSubmitting(true);

        login(credentials)
            .then((res) => {
                if (res.data.primeiro_acesso) {
                    props.history.push(`/primeiro-acesso?usuario=${credentials.usuario}`);

                    return;
                }

                utils.setStorage("authToken", res.data.token, null);

                props.login(res.data);
            })
            .catch((err) => {
                showAlert({
                    icon: "error",
                    title: "Ops!",
                    text: Array.isArray(err?.response?.data?.errors) ? err?.response?.data?.errors[0] : "Parece que houve um problema. Por favor, entre em contato com o suporte.",
                    textStyle: { textAlign: "center" },
                    confirmButton: true,
                    confirmText: "Ok",
                });
            })
            .finally(() => setSubmitting(false));
    };

    if (step === 5) {
        return (
            <div className={styles.authContainer}>
                <div className={styles.loginContainer}>
                    <div className={styles.loginLeft}>
                        <img src={"/images/logo.png"} alt="Suria Logo" className={styles.logoImg} />

                        <div className={styles.boxPagamentoConfirmado}>
                            <img className={styles.checkIcon} src={"/images/check-icon.png"} alt="Pagamento Confirmado" />

                            <div>
                                <p className={styles.textoConfirmado}>Pagamento confirmado!</p>

                                <p className={styles.textoConfirmadoExtra}>Agora você já pode registrar suas transações e acessar o Painel SUR.IA para controlar suas finanças de forma inteligente.</p>
                            </div>

                            <div className={styles.boxBotoesConfirmado}>
                                <button type="button" className={styles.buttonVoltarLogin} onClick={entrar} disabled={submitting}>
                                    {!submitting ? "Ir para o Painel do Cliente" : <div className="icon-loading" style={{ color: "#0d9f0a" }} />}
                                </button>

                                <button className={styles.buttonConversar} onClick={() => window.open(`https://wa.me/${Constants.numeroWhatsapp}`, "_blank")}>
                                    Conversar com minha Assistente SUR.IA
                                    <RiWhatsappLine size={20} color="#FFFFFF" />
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className={styles.loginRight}>
                        <div className={styles.imagemLateralLogin} style={{ backgroundImage: "url(/images/lateral-login.png)" }} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.authContainer}>
            <div className={styles.loginContainer}>
                <div className={styles.loginLeft}>
                    <img src={"/images/logo.png"} alt="Suria Logo" className={styles.logoImg} />

                    <div className={styles.containerFormCadastro}>
                        <button type="button" className={styles.buttonBack} onClick={returnButton}>
                            <ArrowBackIosIcon />

                            <p>{textoReturnButton()}</p>
                        </button>

                        <p className={styles.textoPrimeiroAcesso}>{textoSubtitulo()}</p>

                        <Formik innerRef={formRef} initialValues={getInitialValues()} validate={validate} onSubmit={onSubmit}>
                            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                                <form noValidate onSubmit={handleSubmit} className={styles.formLoginContainer}>
                                    {step === 1 && <Step1 values={values} errors={errors} touched={touched} handleChange={handleChange} handleBlur={handleBlur} submitting={submitting} />}

                                    {step === 2 && <Step2 values={values} errors={errors} touched={touched} handleChange={handleChange} handleBlur={handleBlur} submitting={submitting} />}

                                    {step === 3 && <Step3 setPlanoSelecionado={setPlanoSelecionado} setStep={setStep} />}

                                    {step === 4 && <Step4 values={values} errors={errors} touched={touched} handleChange={handleChange} handleBlur={handleBlur} submitting={submitting} planoSelecionado={planoSelecionado} setFieldValue={setFieldValue} />}

                                    {step !== 3 && (
                                        <div className={`${styles.buttonContainer} ${styles.paddingButton}`}>
                                            <button type="submit" className={styles.buttonLogin} disabled={submitting}>
                                                {!submitting ? step === 4 ? "Realizar pagamento" : "Continuar" : <div className="icon-loading" />}
                                            </button>
                                        </div>
                                    )}
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>

                <div className={styles.loginRight}>
                    <div className={styles.imagemLateralLogin} style={{ backgroundImage: "url(/images/lateral-login.png)" }} />
                </div>
            </div>
        </div>
    );
};

export default connect(null, { ...auth.actions, ...config.actions })(Signin);
